(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lami-product-display-sku"] && !Shopify.designMode) return;
  try {
    (function() {
    document.addEventListener("variant:changed", function(event) {
      const skuEl = document.querySelector("[data-product-sku]");
      const barcodeEl = document.querySelector("[data-product-barcode]");
      const variant = event.detail && event.detail.variant;
      if (skuEl) skuEl.textContent = variant && variant.sku ? variant.sku : "";
      if (barcodeEl) barcodeEl.textContent = variant && variant.barcode ? variant.barcode : "";
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
